import React from 'react';

const DevOpsSkills = () => {
    return (
        <React.Fragment>
            <div className="block-title">
                <h3>Dev Ops Skills</h3>
            </div>
            <div className="skills-info">
                <h4>Amazon Web Sevices</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-3" />
                </div>
                <h4>Jenkins</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-2" />
                </div>
                <h4>Docker</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-5" />
                </div>
                <h4>Kubernetes</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-2" />
                </div>
            </div>
        </React.Fragment>
    );
};

export default DevOpsSkills;